import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapContextToDataTable as mapData } from "./Helper";
import GetTTSContextColumns from "./ColumnDefinition/TTSContextColumn/GetTTSContextColumns";

const TTSContextTable = ({ data, handleDelete, handleOpenPopup, status }) => {
  const columns = GetTTSContextColumns({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={450} />
  );
};

export default TTSContextTable;
